import { normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["rows", "value"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("textarea", {
    class: _normalizeClass(["shadow-sm text-sm", $props.theme]),
    rows: $props.rows,
    value: $props.value,
    onInput: _cache[0] || (_cache[0] = ($event: any) => ($setup.handleInput($event.target.value)))
  }, null, 42, _hoisted_1))
}